import React, { useRef } from 'react';
import styles from './Header.styles.scss';
import OtaLogo from '../../assets/images/logo.png';
import cn from 'classnames';
import { LanguageSelect } from './components/LanguageSelect';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { PERMISSIONS } from '../../helpers/auth';
import { useAuthentication } from '../../hooks/useAuthentication';

const Header = ({ t, onHomeClick, user, logout, login }) => {
  const logo = OtaLogo;
  const menuRef = useRef(null);
  const history = useNavigate();
  const { i18n } = useTranslation();
  const { hasRole } = useAuthentication();

  return (
    <div className={cn(styles.header)}>
      <div className={cn(styles.logoAndHome, 'fluid col-4')}>
        <Button link className="p-0" onClick={onHomeClick}>
          <img src={logo} className={cn(styles.logo)} alt="logo" />
        </Button>
      </div>
      <div className={cn(styles.innerDiv, 'hstack gap-3 p-3 d-md-flex')}>
        <div>
          <LanguageSelect className={cn(styles.changeLanguage, 'col-6')} />
        </div>
        <div className={cn('vr', styles.divider)} />
        <div className={cn('ms-auto d-flex align-items-center')}>
          {user && (
            <>
              <span className={cn('text-center', styles.avatarInitials)}>
                {user?.firstName
                  ?.split(' ')
                  .map((name) => name.charAt(0))
                  .join('')
                  .substring(0, 3)
                  .toUpperCase()}
              </span>
              <div>
                <Menu
                  popup
                  ref={menuRef}
                  model={[
                    hasRole(PERMISSIONS.MANAGE_POINTS_CONTACTS) && {
                      label: t('manage-notifications.title'),
                      command: () => {
                        history(`/${i18n.language}/manage-notifications`);
                      },
                    },
                    { label: t('logout'), command: logout },
                  ].filter(Boolean)}
                  className={styles.menu}
                />
                <Button
                  className={cn('dropdown', styles.userButton)}
                  label={user?.firstName + ' ' + user?.lastName}
                  icon="pi pi-chevron-down"
                  iconPos="right"
                  onClick={(event) => menuRef.current.toggle(event)}
                />
              </div>
            </>
          )}
          {!user && (
            <div className={cn('col-4 fluid', styles.nameAndLang)}>
              <Button className={cn(styles.loginButton)} onClick={login}>
                {t('login_page_login')}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(Header);
